import { NodeModel } from "../_model/NodeModel";
import { DecorationRegeneratorD } from "./decorationRegeneratorD";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class RegeneratorD extends NodeModel {
  constructor() {
    super("RegeneratorD");

    this.type = new Types().RegeneratorD;
    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 140;
    this.width = 130;
    this.operationSelected = "";
    this.srcImg = require("@/assets/Fluxogramas/regenerador.png");
    this.data = [new Properties({...this })];
    this.jokerCaption = [];

    this.decorate = async function(callback) {
      this.decorator = new DecorationRegeneratorD();
      await this.decorator.init(this, callback);
    };

    this.clone = () => {
      let cloned = new RegeneratorD();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.decorator = null;
      cloned.readOnly = this.readOnly;
      cloned.expressionVisible = this.expressionVisible
      cloned.jokerCaption = this.jokerCaption
      cloned.data = this.data.map((d) => d.clone());

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.jokerCaption = node.jokerCaption
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      if (node.attrs) {
        this.data = node.attrs;
      }
      this.jokerCaption = node.jokerCaption;
    };

    this.rebuildStructure = (newProps = []) => {
      let newData = [];
      this.jokerCaption = [];

      newProps.forEach(prop => {
        let enabled = prop.key == "Enabled" && prop.subType == "Atributos";
        let equipments = prop.subType == "Equipamentos" && prop.key == "Status";
        let Tsaida = prop.key == "TSaida" && prop.subType == "Atributos";
        let area = prop.key == "area" && prop.subType == "Atributos";
        let TSaidaFluido1 = prop.key == "TSaidaFluido1" && prop.subType == "Atributos";
        let TSaidaFluido2 = prop.key == "TSaidaFluido2" && prop.subType == "Atributos";

        if (equipments || area || Tsaida || TSaidaFluido1 || TSaidaFluido2 || enabled) {
          newData.push(new Properties({ ...prop }));
        }
      });
      if (newData.length > 0) this.data = newData;
    }
  }
}

export { RegeneratorD };
